module.exports = __webpack_public_path__ + "img/edge_patrimoine_religieux.a4a28283.svg";